<template>
    <div ref="sideMenuContainer" class="menu-wrapper">
        <interactive ref="sideMenuIcon" class="menu-icon" :class="menuOpened ? 'open' : 'closed'" @click="menuOpened = !menuOpened" jumpSize="big">
            <div class="line top"></div>
            <div class="line center"></div>
            <div class="line bottom"></div>
        </interactive>
        <div class="side-menu" :class="{ 'opened': menuOpened }">
            <div class="content">
                <div class="options">
                    <interactive v-for="option in options" :key="option.name" class="option" :class="option.type" @click="option.function">
                        <p v-parse-emojis class="name">{{  option.name }}</p>
                        <p class="description">{{  option.description }}</p>
                    </interactive>
                </div>
                <interactive v-if="you" class="settings-option" @click="handleNavigateToSettings">
                    <div class="left">
                        <avatar :avatar="you ? you.base64avatar : null"></avatar>

                        <div class="text">
                            <p><strong>Profiel & instellingen</strong></p>
                        </div>
                    </div>
                    <!-- <svg class="icon" x="0px" y="0px" width="32" height="32" viewBox="0 0 50 50">
                        <path d="M47.16,21.221l-5.91-0.966c-0.346-1.186-0.819-2.326-1.411-3.405l3.45-4.917c0.279-0.397,0.231-0.938-0.112-1.282 l-3.889-3.887c-0.347-0.346-0.893-0.391-1.291-0.104l-4.843,3.481c-1.089-0.602-2.239-1.08-3.432-1.427l-1.031-5.886 C28.607,2.35,28.192,2,27.706,2h-5.5c-0.49,0-0.908,0.355-0.987,0.839l-0.956,5.854c-1.2,0.345-2.352,0.818-3.437,1.412l-4.83-3.45 c-0.399-0.285-0.942-0.239-1.289,0.106L6.82,10.648c-0.343,0.343-0.391,0.883-0.112,1.28l3.399,4.863 c-0.605,1.095-1.087,2.254-1.438,3.46l-5.831,0.971c-0.482,0.08-0.836,0.498-0.836,0.986v5.5c0,0.485,0.348,0.9,0.825,0.985 l5.831,1.034c0.349,1.203,0.831,2.362,1.438,3.46l-3.441,4.813c-0.284,0.397-0.239,0.942,0.106,1.289l3.888,3.891 c0.343,0.343,0.884,0.391,1.281,0.112l4.87-3.411c1.093,0.601,2.248,1.078,3.445,1.424l0.976,5.861C21.3,47.647,21.717,48,22.206,48 h5.5c0.485,0,0.9-0.348,0.984-0.825l1.045-5.89c1.199-0.353,2.348-0.833,3.43-1.435l4.905,3.441 c0.398,0.281,0.938,0.232,1.282-0.111l3.888-3.891c0.346-0.347,0.391-0.894,0.104-1.292l-3.498-4.857 c0.593-1.08,1.064-2.222,1.407-3.408l5.918-1.039c0.479-0.084,0.827-0.5,0.827-0.985v-5.5C47.999,21.718,47.644,21.3,47.16,21.221z M25,32c-3.866,0-7-3.134-7-7c0-3.866,3.134-7,7-7s7,3.134,7,7C32,28.866,28.866,32,25,32z" fill="white"></path>
                    </svg> -->
                </interactive>
            </div>
        </div>

        <popup-modal :show="showDeletePopup" important>
            <template #content>
                <p class="message">
                    Weet je zeker dat je deze pot wilt verwijderen?
                </p>
            </template>
            <template #footer>
                <custom-button variation="white" size="medium" @click="showDeletePopup = false;">Annuleren</custom-button>
                <custom-button variation="danger" size="medium" @click="$emit('deleteGame')">Verwijderen</custom-button>
            </template>
        </popup-modal>

        <popup-modal :show="showSharePopup" important>
            <template #content>
                <div class="flex flex-column align-center">
                    <p class="message">
                        Laat iemand deze QR Code scannen of stuur een link via whatsapp!
                    </p>

                    <div style="padding-top:33px;padding-bottom:12px;">
                        <canvas id="canvas" class="qr-code"></canvas>
                    </div>
                </div>
            </template>
            <template #footer>
                <custom-button variation="white" size="medium" @click="handleCloseSharePopup">Sluiten</custom-button>
                <custom-button variation="primary" size="medium" @click="handleCopyGameLink">Delen</custom-button>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import PopupModal from '@/components/PopupModal.vue';
import CustomButton from '@/components/CustomButton.vue';
import Interactive from '@/components/Interactive.vue';
import Avatar from '@/components/Avatar.vue';

import QRCode  from 'qrcode';

export default {
    name: 'side-menu',
    components: {
        PopupModal,
        CustomButton,
        Interactive,
        Avatar,
    },
    props: {
        view: {
            type: String,
            required: true
        },
        user: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            menuOpened: false,
            animateLine: false,
            showDeletePopup: false,
            showSharePopup: false,
            you: this.user,
            playingGame: null,
        }
    },
    methods: {
        close() {
            this.menuOpened = false;
            this.showDeletePopup = false;
        },
        handleMenuItemClick(view) {
            this.$emit('updateView', view);
            this.close();
        },
        handleManagePlayers() {
            this.menuOpened = false;
            this.$root.$emit('managePlayerOrder');
        },
        handleReadRules() {
            window.location.href = '/rules';
        },
        async handleShareGame() {
            this.showSharePopup = true;
            
            await this.$nextTick();
            
            var canvas = document.getElementById('canvas');
            const windowWidth = window.innerWidth;
            QRCode.toCanvas(canvas, window.location.href, { width: windowWidth * 0.4, 'color.dark': '#FF0000' }, function (error) {
                if (error) console.error(error)
                console.log('success!');
            });
            this.close();
        },
        handleCloseSharePopup() {
            this.showSharePopup = false;
            this.close();
        },
        async handleCopyGameLink() {
            try {
                await navigator.share({
                    title: "JP",
                    text: "Check hier jouw score en die van je medespelers!",
                    url: window.location.href,
                });
            } catch (err) {
                const anchor = document.createElement('a');
                anchor.href = `whatsapp://send?text=Check hier jouw score en die van je medespelers! ${window.location.href}`;
                anchor.setAttribute('data-action','share/whatsapp/share');
                document.body.appendChild(anchor);
                anchor.click();
                document.body.removeChild(anchor);
            }

            this.close();
        },
        handleClickElement(target) {
            if(!this.menuOpened) return
            if(!this.$refs.sideMenuContainer.contains(target) && !this.$refs.sideMenuIcon.$el.contains(target)) this.menuOpened = false;
        },
        handleShowDeletePopup() {
            this.showDeletePopup = true;
        },
        handleNavigateToSettings() {
            this.$emit('updateView', 'settings');
            this.close();
        },
        handleShowAdminPage() {
            this.$router.push('/customnotifications');
        },
    },
    computed: {
        options() {
            const isPlayingGamePlayer = (this.you && this.playingGame?.userIds.includes(this.you.id)) || this.isAdmin;
            const isPlayingGameCreator = (this.you && this.playingGame?.createdUserId ? this.playingGame.createdUserId === this.you.id : true) || this.isAdmin;

            const options = [
                {
                    name: 'Spelregels',
                    description: 'Lees hier de spelregels van JP!',
                    function: this.handleReadRules,
                    show: true,
                },
                {
                    name: 'Pot delen',
                    description: 'Kopieer de link van dit potje en stuur deze naar je medespelers',
                    function: this.handleShareGame,
                    show: this.view === 'play-game' && isPlayingGamePlayer,
                },
                {
                    name: 'Spelers beheren',
                    description: 'Beheer de volgorde van de spelers, deze volgorde moet altijd kloppen!',
                    function: this.handleManagePlayers,
                    show: this.view === 'play-game' && isPlayingGamePlayer,
                },
                {
                    name: 'Pot verwijderen',
                    description: 'Gaat er iets fout of schaam je je voor jouw prestaties? Dan kan je hem hier verwijderen',
                    function: this.handleShowDeletePopup,
                    show: this.view === 'play-game' && isPlayingGameCreator,
                    type: 'danger',
                },
                {
                    name: 'Admin pagina',
                    description: 'Voor snelle fixes en dergelijken',
                    function: this.handleShowAdminPage,
                    show: this.isAdmin,
                },
            ];

            return options.filter(option => option.show);
        },
        isAdmin() {
            if (!this.you) return false;

            return this.you.id === 'b4d7b605-eb92-4067-839f-b7c42997e819';
        }
    },
    mounted() {
        this.$root.$on('clickElement', this.handleClickElement);
        this.$root.$on('popstate', this.close);
    },
    beforeDestroy() {
        this.$root.$off('clickElement', this.handleClickElement);
        this.$root.$off('popstate', this.close);
    },
    watch: {
        user() {
            this.you = this.user;
        },
        menuOpened() {
            let playingGame = localStorage.getItem('playingGame');
            if (playingGame && this.view === 'play-game') this.playingGame = JSON.parse(playingGame);
        }
    }
}
</script>

<style lang="scss" scoped>

.side-menu {
    position: absolute;
    width: 80%;
    height: calc(100dvh - 80px);
    top: 0;
    right: 0;
    padding-top: 80px;
    background: #0b1c0790;
    transform: translateX(100%);
    transition: 500ms cubic-bezier(.7,.05,.31,.95);
    -webkit-transition: 500ms cubic-bezier(.7,.05,.31,.95);
    z-index: 201;

    &.opened {
        transform: translateX(0);
        transition: 800ms cubic-bezier(.7,.05,.31,.95);
        -webkit-transition: 800ms cubic-bezier(.7,.05,.31,.95);
    }

    .content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 12px;
        padding: 20px;
        height: calc(100% - 40px);

        .options {
            display: flex;
            flex-direction: column;
            gap: 12px;
            margin-right: -20px;

            .option {
                padding: 14px 14px;
                padding-right: 34px;
                margin-right: -20px;
                background: #0d1b0aae;
                border-radius: 12px 0 0 12px;
                outline: 2px solid #FFFFFF80;

                .name {
                    color: white;
                    font-size: 20px;
                    font-weight: 600;
                }
                .description {
                    margin-top: 4px;
                    color: rgb(136, 146, 132);
                    font-size: 12px;
                    line-height: 16px;
                    font-weight: 400;
                }

                &.danger {
                    outline: 2px solid red;
                    background: #5e000080;
                }
            }
        }

        .settings-option {
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: white;
            padding: 8px 12px;
            margin: -8px -8px;
            border-radius: 12px;
            background: #0d1b0aae;

            .left {
                display: flex;
                align-items: center;
                gap: 12px;

                .avatar {
                    width: 40px;
                    height: 40px;
                }

            }
            .right {
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
        
        }
    }
}

.menu-icon {
    --menu-width: 30px;
    --menu-height: 24px;
    --transition-duration: 800ms;
    --transition-delay: 400ms;
    --animation-length: 1200ms;
    --line-height: 3px;
    --line-gap: 7px;

    position: absolute;
    top: 26px;
    right: 26px;
    pointer-events: all;
    z-index: 202;

    width: var(--menu-width);
    height: var(--menu-height);

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: var(--line-gap);

    padding: 8px;
    margin: -8px;

    --margin-duration: 300ms;
    --rotate-duration: 400ms;

    --overturn-degrees: 6deg;
    // --overturn-degrees: 0deg;

    transition: rotate 700ms cubic-bezier(.15,.6,.2,1) var(--rotate-delay, 0ms), transform 350ms cubic-bezier(.63,.54,.27,.74) calc(450ms + var(--rotate-delay, 0ms));

    &.open {
        --rotate-delay: 150ms;
        transform: rotate(calc(var(--overturn-degrees) * -1));
        rotate: calc(270deg + var(--overturn-degrees));

        .top {
            margin-bottom: calc((var(--line-gap) + var(--line-height)) * -1);
            rotate: 45deg;
            // --rotate-duration: 250ms;
        }
        .center {
            rotate: 45deg;
            // --rotate-duration: 250ms;
        }
        .bottom {
            margin-top: calc((var(--line-gap) + var(--line-height)) * -1);
            rotate: 135deg;
            --rotate-duration: 450ms;
        }
        .line {
            transition: margin calc(var(--margin-duration)) ease, rotate calc(var(--rotate-duration)) ease-out 200ms;
        }
    }
    
    &.closed {
        transform: rotate(var(--overturn-degrees));
        rotate: calc(0deg - var(--overturn-degrees));
        --rotate-delay: 100ms;

        .top {
            margin-bottom: 0;
            rotate: 0deg;
            --delay: 200ms;
        }
        .center {
            rotate: 0deg;
            --delay: 200ms;
        }
        .bottom {
            margin-top: 0;
            rotate: 0deg;
            --rotate-duration: 200ms;
            --delay: 0ms;
        }
        .line {
            transition: margin calc(var(--margin-duration)) cubic-bezier(.51,1.4,.45,1.08) 150ms, rotate calc(var(--rotate-duration)) ease-out var(--delay);
        }
    }
    
    .top {
        --scale-delay: 200ms;
    }
    .center {
        --scale-delay: 300ms;
    }
    .bottom {
        --scale-delay: 400ms;
    }

    .line {
        width: var(--menu-width);
        height: var(--line-height);
        border-radius: 3px;
        background-color: white;
        transform-origin: center;
        scale: 0;
        animation: scaleIn 500ms cubic-bezier(.51,1.2,.45,1.08) var(--scale-delay, 0ms) forwards;
    }
}

@keyframes scaleIn {
    from {
        scale: 0;
    } to {
        scale: 1;
    }
}

@keyframes scaleAnimationLeave {
    0% {
        scale: 1;
    } 35% {
        scale: 1.25;
    } 70%, 100% {
        scale: 0;
    }
}
@keyframes scaleAnimationEnter {
    0% {
        scale: 0;
    } 35% {
        scale: 1.25;
    } 100% {
        scale: 1;
    }
}

</style>